<div mat-dialog-content id="public-key-modal" *ngIf="data.isPublicKey">
    <button mat-raised-button class="close-button" (click)="onClose()">
        <mat-icon>close</mat-icon>
    </button>
    <p class="center">{{data.publicKey}}</p>
</div>

